import React from 'react';
import { Card as AntdCard, type CardProps as AntdCardProps } from 'antd';

export type CardProps = Omit<AntdCardProps, 'actions'> & {
    actions?: React.ReactNode;
};

type CardComponent = React.ForwardRefExoticComponent<
    CardProps & React.RefAttributes<HTMLDivElement>
> & {
    Grid: typeof AntdCard.Grid;
    Meta: typeof AntdCard.Meta;
};

const Card = React.forwardRef<HTMLDivElement, CardProps>(
    ({ actions, ...props }, ref) => {
        const antdActions = Array.isArray(actions)
            ? actions
            : actions
              ? [<React.Fragment key="actions">{actions}</React.Fragment>]
              : undefined;

        return <AntdCard ref={ref} actions={antdActions} {...props} />;
    },
) as CardComponent;

Card.displayName = 'Card';
Card.Grid = (AntdCard as typeof AntdCard | undefined)
    ?.Grid as typeof AntdCard.Grid;
Card.Meta = (AntdCard as typeof AntdCard | undefined)
    ?.Meta as typeof AntdCard.Meta;

export { AntdCard };
export default Card;
